import { render, staticRenderFns } from "./KeyTwentyFive.vue?vue&type=template&id=37a1ec57&scoped=true&"
import script from "./KeyTwentyFive.vue?vue&type=script&lang=js&"
export * from "./KeyTwentyFive.vue?vue&type=script&lang=js&"
import style0 from "./KeyTwentyFive.vue?vue&type=style&index=0&id=37a1ec57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a1ec57",
  null
  
)

export default component.exports